import { Col, Row } from 'react-bootstrap';
import React from 'react';
import { IoStarSharp } from 'react-icons/io5';
import { ReviewComment } from './ReviewComment';
import { IReviewsReportItems } from '../../../../../../../../model/book/Book';
import { CustomImageHandler } from '../../../../../../../../shared/components/CustomImageHandler';
import { formatDate, truncateString } from '../../../../../../../../shared/functions/Functions';
import { IPicture } from '../../../../../../../../model/shared/IPicture';
import CardLayout from '../../../../../../../../shared/components/card/CardLayout';
import { formatRating } from '../../../../../../../../shared/components/RatingStar';

interface IFeedbackCardProps {
    brandLogo: Partial<IPicture>;
    brandName: string;
    campaignName: string;
    reviewScore: string;
    reviewText: string;
    influencerName: string;
    influencerFeedback: string;
    influencerPhoto: string;
    influencerComment: string;
    createdAt: string;
    hasReply: boolean;
    isContentAttached: boolean;
    reportItems: IReviewsReportItems[];
}

export const FeedbackCard = ({
    brandLogo,
    brandName,
    campaignName,
    influencerComment,
    reviewScore,
    reviewText,
    createdAt,
    hasReply,
    reportItems,
    influencerName,
    isContentAttached,
    influencerFeedback,
    influencerPhoto,
}: IFeedbackCardProps) => {
    return (
        <CardLayout classCard="my-3">
            <Row>
                <Col xs={3} md={1}>
                    <CustomImageHandler
                        altTag="Brand logo"
                        classes="rounded-img-sm"
                        photoPath={brandLogo?.thumbnail ?? null}
                    />
                </Col>
                <Col xs={9} md={11}>
                    <div className="d-flex align-items-center">
                        <h6>{brandName} </h6>
                        <h6 className="text-muted font-14 font-weight-bold text-decoration-none">
                            {!!campaignName && <span className="px-2">-</span>}
                            {truncateString(campaignName, 30)}
                        </h6>
                    </div>
                    <div className="d-flex justify-content-between flex-wrap">
                        <div className="word-break d-sm-flex">
                            <div className="text-primary pr-3">{createdAt}</div>
                        </div>
                        <span className="font-weight-bold d-flex align-items-center justify-content-center">
                            {formatRating(Number(reviewScore ?? 0))}
                            <IoStarSharp className="text-primary rating-icon-bg ml-2" />
                        </span>
                    </div>
                    {reviewText ? <p className="mt-2 mb-0">{reviewText}</p> : '-'}
                    <Row>
                        {isContentAttached &&
                            reportItems?.map((item: IReviewsReportItems) => {
                                return (
                                    <React.Fragment key={item?.id}>
                                        {item?.relatedFeedItem?.postImages?.map(reportImage => {
                                            return (
                                                <Col sm={4} lg={3} key={reportImage?.id}>
                                                    <CustomImageHandler
                                                        altTag="Review logo"
                                                        classes="review-image"
                                                        thumbnailPath={reportImage?.thumbnail}
                                                        photoPath={reportImage?.thumbnail}
                                                    />
                                                </Col>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            })}
                    </Row>
                </Col>
            </Row>
            <div className="pl-5">
                {hasReply && (
                    <ReviewComment
                        influencerPhoto={influencerPhoto}
                        influencerName={influencerName}
                        influencerComment={formatDate(influencerComment)}
                        influencerFeedback={influencerFeedback}
                    />
                )}
            </div>
        </CardLayout>
    );
};
